import {
    UPLOAD_FILE,
    CREATE_ATTACHMENT
} from "@/store/actions.type"

import {
    POST_UPLOADS,
    POST_ATTACHMENTS
} from '@/store/media.type'

import utilities from "@/base/utilities"

export default {
    methods: {
        fileUploads(files, type, postId) {
            let uploadedFiles = Array.from(files)

            // if (uploadedFiles.length > 10) { // If photos greater then 10, take 10 and set error
            //     uploadedFiles = uploadedFiles.slice(0, 10)
            // }

            uploadedFiles.forEach(file => {
                let fileName = file.name
                if (fileName.lastIndexOf('.') <= 0) {
                    return alert("Please add a vallid file")
                }

                let fileNameTrimmed = fileName.replace(/\s/g, '').split('.')[0]

                const fileReader = new FileReader() // Creating File reader for thumbnails and details
                fileReader.addEventListener('load', (e) => {
                    // Creating a thumbnail and dispatch photosent
                    utilities.createThumbnail(file, e)
                        .then(thumbnail => {
                            // After filereader loaded the file and thumbnail created
                            const photo = {
                                type: type,
                                file: file,
                                file_name: new Date().getTime() + '-' + fileName,
                                file_url: fileReader.result,
                                id: new Date().getTime() + fileNameTrimmed,
                                thumbnail: thumbnail.thumbnailFile,
                                thumbnail_file_url: thumbnail.thumbnailUrl
                            }

                            let action = ''
                            switch (type) {
                                case POST_UPLOADS:
                                    action = UPLOAD_FILE
                                    break
                                case POST_ATTACHMENTS:
                                    action = CREATE_ATTACHMENT
                                    break
                                default:
                                    action = ''
                            }
                            if (action) this.$store.dispatch(action, {
                               photo,
                               postId: postId ? postId : ''
                            })
                        })
                })
                fileReader.readAsDataURL(file)
            })
        }
    }
}